import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModalModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

import { QuestionnairesComponent } from '../questionnaires/questionnaires.component';
import { QuestionnairesGroupComponent } from '../questionnaires-group/questionnaires-group.component';

import { QuestionnairePanelRoutingModule } from './questionnaire-panel-routing.module';


@NgModule({
  imports: [
    CommonModule,
    QuestionnairePanelRoutingModule,
    HttpClientModule,
    NgbModalModule,
    NgbPaginationModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    LoadingBarHttpClientModule
  ],
  declarations: [
    QuestionnairesComponent,
    QuestionnairesGroupComponent
  ]
})
export class QuestionnairePanelModule { }
